/**
 * Fallback handler: no-get-user-media
 *
 * Fires when the browser feature-detect for navigator.mediaDevices.getUserMedia
 * fails — the API does not exist at all (old browser, insecure context, etc.).
 * No retry action since this is a browser-capability failure.
 */

import type { FallbackBanner } from "@/voice/types";

export function makeNoGetUserMediaBanner(): FallbackBanner {
  return {
    kind: "no-get-user-media",
    message:
      "Your browser does not support microphone access. Try a modern browser over HTTPS.",
  };
}
